import { Helpers } from './helpers'
import { abTestService } from '../services/abTestService'
import posthog from 'posthog-js'

export class AnalyticsManager {
  static isOverridingFeatureFlags = false;

  static sanitizeKeyForFirebaseFb = (str) => {
    let string = Helpers.replaceAllInString(str.substr(0, 32), '-', '_')
    string = Helpers.replaceAllInString(string, ' ', '_')
    string = Helpers.replaceAllInString(string, '&', '_and_')
    return string.toLowerCase()
  }

  // check experiment variants for a given experiment
  static async checkExperimentVariant(experimentName, experimentVariant) {
      const featureFlag = posthog.getFeatureFlag(experimentName);
      return featureFlag === experimentVariant;
  }

  // get the current experiment variant from posthof
  static async getExperimentVariant(experimentName) {
    const featureFlag = posthog.getFeatureFlag(experimentName);
    return featureFlag;
  }

  static async forceExperimentVariant(experimentName, variantName) {
    if (this.isOverridingFeatureFlags) {
      // Feature flag override is already in progress. Skipping
      return ;
    }

    this.isOverridingFeatureFlags = true;

    try {
      const configObj = {}
      configObj[`${experimentName}`] = variantName
      posthog.featureFlags.overrideFeatureFlags(configObj)

      return true;
    } catch (error) {
      console.error("forceExperimentVariant:", error);
    } finally {
      this.isOverridingFeatureFlags = false;
    }
  }

  static captureEvent = async (eventName) => {
    const user = await Helpers.getAuthUser()
    posthog.capture(eventName, {
      $set: { name: `${user.first_name} ${user.last_name}`, email: user.email }
    })
  }

  static capturePageView = () => {
    posthog.capture('$pageview')
  }

  static identifyUser = (userId, properties) => {
    posthog.identify(userId, properties)
  }

  static resetUserIdentity = () => {
    posthog.reset()
  }

  static registerStaticEventDetails = (properties) => {
    posthog.register(properties)
  }

  // create an A/B test experiment
  static trackExperiment = async (experimentName, variantName, isAgent, vehicle) => {
      const user = await Helpers.getAuthUser()
      const experimentParams = {
        user_id: user.id,
        experiment_name: experimentName,
        variant_name: variantName,
        product: 'motor',
        entity: isAgent ? 'agent' : 'user',
        platform: 'web',
        vehicle_id: vehicle?.id
      }

      // Assuming abTestService is available here
      const result = await abTestService.trackExperiment(experimentParams)
      return result
    
  }
}
